const cityListData = [{
        cityId: "228",
        cityName: "日照"
    }, {
        cityId: "60",
        cityName: "青岛"
    }, {
        cityId: "227",
        cityName: "威海"
    }, {
        cityId: "65",
        cityName: "大连"
    }, {
        cityId: "107",
        cityName: "贵阳"
    }, {
        cityId: "129",
        cityName: "大同"
    }, {
        cityId: "55",
        cityName: "南京"
    }, {
        cityId: "139",
        cityName: "呼和浩特"
    }, {
        cityId: "66",
        cityName: "沈阳"
    }, {
        cityId: "1",
        cityName: "北京"
    }, {
        cityId: "108",
        cityName: "珠海"
    }, {
        cityId: "42",
        cityName: "西安"
    }, {
        cityId: "387",
        cityName: "乌鲁木齐"
    }, {
        cityId: "104",
        cityName: "烟台"
    }, {
        cityId: "122",
        cityName: "秦皇岛"
    }, {
        cityId: "96",
        cityName: "济南"
    }, {
        cityId: "361",
        cityName: "兰州"
    }, {
        cityId: "374",
        cityName: "西宁"
    }, {
        cityId: "30",
        cityName: "深圳"
    }, {
        cityId: "81",
        cityName: "淄博"
    }, {
        cityId: "40",
        cityName: "天津"
    }, {
        cityId: "70",
        cityName: "长沙"
    }, {
        cityId: "50",
        cityName: "杭州"
    }, {
        cityId: "101",
        cityName: "太原"
    }, {
        cityId: "57",
        cityName: "武汉"
    }, {
        cityId: "119",
        cityName: "徐州"
    }, {
        cityId: "213",
        cityName: "景德镇"
    }, {
        cityId: "59",
        cityName: "成都"
    }, {
        cityId: "186",
        cityName: "湖州"
    }, {
        cityId: "83",
        cityName: "南昌"
    }, {
        cityId: "190",
        cityName: "舟山"
    }, {
        cityId: "283",
        cityName: "汕尾"
    }, {
        cityId: "226",
        cityName: "泰安"
    }, {
        cityId: "117",
        cityName: "汕头"
    }, {
        cityId: "80",
        cityName: "苏州"
    }, {
        cityId: "147",
        cityName: "乌兰察布"
    }, {
        cityId: "10",
        cityName: "上海"
    }, {
        cityId: "116",
        cityName: "长春"
    }, {
        cityId: "105",
        cityName: "哈尔滨"
    }, {
        cityId: "56",
        cityName: "合肥"
    }, {
        cityId: "20",
        cityName: "广州"
    }, {
        cityId: "62",
        cityName: "厦门"
    }, {
        cityId: "114",
        cityName: "昆明"
    }, {
        cityId: "73",
        cityName: "郑州"
    }, {
        cityId: "99",
        cityName: "南宁"
    }, {
        cityId: "92",
        cityName: "佛山"
    }, {
        cityId: "281",
        cityName: "惠州"
    }, {
        cityId: "89",
        cityName: "常州"
    }, {
        cityId: "44",
        cityName: "福州"
    }, {
        cityId: "51",
        cityName: "宁波"
    }, {
        cityId: "172",
        cityName: "伊春"
    }, {
        cityId: "236",
        cityName: "洛阳"
    }, {
        cityId: "398",
        cityName: "伊犁哈萨克自治州"
    }, {
        cityId: "292",
        cityName: "北海"
    }, {
        cityId: "366",
        cityName: "张掖"
    }, {
        cityId: "344",
        cityName: "迪庆藏族自治州"
    }, {
        cityId: "368",
        cityName: "酒泉"
    }, {
        cityId: "168",
        cityName: "延边朝鲜族自治州"
    }, {
        cityId: "110",
        cityName: "泉州"
    }, {
        cityId: "381",
        cityName: "海西蒙古族藏族自治州"
    }, {
        cityId: "125",
        cityName: "张家口"
    }, {
        cityId: "93",
        cityName: "桂林"
    }, {
        cityId: "76",
        cityName: "石家庄"
    }, {
        cityId: "45",
        cityName: "重庆"
    }, {
        cityId: "113",
        cityName: "中山"
    }, {
        cityId: "341",
        cityName: "大理白族自治州"
    }, {
        cityId: "91",
        cityName: "东莞"
    }, {
        cityId: "121",
        cityName: "唐山"
    }, {
        cityId: "196",
        cityName: "铜陵"
    }, {
        cityId: "52",
        cityName: "无锡"
    }, {
        cityId: "364",
        cityName: "天水"
    }, {
        cityId: "94",
        cityName: "海口"
    }, {
        cityId: "188",
        cityName: "金华"
    }, {
        cityId: "136",
        cityName: "忻州"
    }, {
        cityId: "271",
        cityName: "郴州"
    }, {
        cityId: "205",
        cityName: "池州"
    }, {
        cityId: "189",
        cityName: "衢州"
    }, {
        cityId: "396",
        cityName: "喀什地区"
    }, {
        cityId: "111",
        cityName: "三亚"
    }, {
        cityId: "400",
        cityName: "阿勒泰地区"
    }, {
        cityId: "235",
        cityName: "开封"
    }, {
        cityId: "224",
        cityName: "潍坊"
    }, {
        cityId: "328",
        cityName: "黔东南苗族侗族自治州"
    }, {
        cityId: "319",
        cityName: "阿坝藏族羌族自治州"
    }, {
        cityId: "322",
        cityName: "六盘水"
    }, {
        cityId: "334",
        cityName: "丽江"
    }, {
        cityId: "327",
        cityName: "毕节"
    }, {
        cityId: "165",
        cityName: "白山"
    }, {
        cityId: "392",
        cityName: "博尔塔拉蒙古自治州"
    }, {
        cityId: "230",
        cityName: "临沂"
    }, {
        cityId: "329",
        cityName: "黔南布依族苗族自治州"
    }, {
        cityId: "338",
        cityName: "红河哈尼族彝族自治州"
    }, {
        cityId: "688",
        cityName: "陵水黎族自治县"
    }, {
        cityId: "324",
        cityName: "安顺"
    }, {
        cityId: "286",
        cityName: "清远"
    }, {
        cityId: "321",
        cityName: "凉山彝族自治州"
    }, {
        cityId: "680",
        cityName: "万宁"
    }, {
        cityId: "187",
        cityName: "绍兴"
    }, {
        cityId: "185",
        cityName: "嘉兴"
    }, {
        cityId: "126",
        cityName: "承德"
    }, {
        cityId: "285",
        cityName: "阳江"
    }, {
        cityId: "290",
        cityName: "柳州"
    }, {
        cityId: "145",
        cityName: "呼伦贝尔"
    }, {
        cityId: "217",
        cityName: "赣州"
    }, {
        cityId: "103",
        cityName: "新乡"
    }, {
        cityId: "123",
        cityName: "邯郸"
    }, {
        cityId: "293",
        cityName: "防城港"
    }, {
        cityId: "206",
        cityName: "宣城"
    }, {
        cityId: "207",
        cityName: "莆田"
    }, {
        cityId: "142",
        cityName: "赤峰"
    }, {
        cityId: "198",
        cityName: "黄山"
    }, {
        cityId: "179",
        cityName: "连云港"
    }, {
        cityId: "120",
        cityName: "扬州"
    }];
export default cityListData;
